import { Container } from "inversify";
import "reflect-metadata";
import { Passthrough } from "../express/passthrough";

export class DI {
	public static readonly container: Container = new Container();

	// Application
	public static readonly TRACKER: symbol = Symbol("Tracker");
	public static readonly DOMAIN_POLICY: symbol = Symbol("DomainPolicy");
	public static readonly ENVIRONMENT: symbol = Symbol("Environment");
	public static readonly BOB_REQUEST_PIPELINE_FACTORY: symbol = Symbol("BobRequestPipelineFactory");
	public static readonly BOB_PORT: symbol = Symbol("BobPort");
	public static readonly BOB_SERVER: symbol = Symbol("BobServer");
	public static readonly CACHING_POLICY: symbol = Symbol("CachingPolicy");
	public static readonly CACHE_PROVIDER: symbol = Symbol("CacheProvider");
	public static readonly CACHE: symbol = Symbol("Cache");
	public static readonly REQUEST_DISPATCHER: symbol = Symbol("RequestDispatcher");
	public static readonly HTML_REPOSITORY: symbol = Symbol("HtmlRepository");
	public static readonly MANIFEST_REPOSITORY: symbol = Symbol("ManifestRepository");
	public static readonly ERROR_REPORTER: symbol = Symbol("ErrorReporter");
	public static readonly PASSTHROUGH: symbol = Symbol("Passthrough");
	public static readonly ERROR_MIDDLEWARE: symbol = Symbol("ErrorMiddleware");
}
